import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';
import { RequestsInstance } from './index';

const LiveBettingPopularApiWrapper = (requests: RequestsInstance) => {
	return {
		getLiveBettingPopular: (categoryIds?: number) => {
			const query: any = {};
			if (categoryIds) query.categoryIds = categoryIds;
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
				params: query,
			};
			return requests.get(`/livebetting/running/popular`, config);
		},
	};
};

export default LiveBettingPopularApiWrapper;
